var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMdiFormOutline = function SvgMdiFormOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 12.5h5v1.667h-5zM7.5 5.833H5.833V7.5H7.5zm1.667 5h5V9.167h-5zm0-3.333h5V5.833h-5zM7.5 9.167H5.833v1.666H7.5zm10-5v11.666c0 .917-.75 1.667-1.667 1.667H4.167c-.917 0-1.667-.75-1.667-1.667V4.167c0-.917.75-1.667 1.667-1.667h11.666c.917 0 1.667.75 1.667 1.667m-1.667 0H4.167v11.666h11.666zM7.5 12.5H5.833v1.667H7.5z"
  })));
};
export default SvgMdiFormOutline;